import React from 'react';
import { Box, Typography, Button, Link } from 'omaha-design-system';
import { useAuth } from '../../hooks/useAuth';

export const UnlockOverlay: React.FC = () => {
  const { login } = useAuth();

  const handleSignIn = () => {
    login('/nbarates/NBA');
  };

  return (
    <Box
      sx={{
        width: '100%',
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      {/* Stokastic Logo */}
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/longLogo.png`}
        alt="Stokastic"
        sx={{
          height: 40,
          width: 'auto',
          mb: 4,
        }}
      />

      {/* Headline */}
      <Typography
        sx={{
          fontFamily: '"Gilroy", "Instrument Sans", sans-serif',
          fontWeight: 700,
          fontSize: { xs: 28, sm: 36 },
          color: 'white',
          textAlign: 'center',
          mb: 1.5,
        }}
      >
        Sign In to Access NBA Rates
      </Typography>

      {/* Supporting text */}
      <Typography
        sx={{
          fontFamily: '"Instrument Sans", sans-serif',
          fontWeight: 400,
          fontSize: 16,
          color: 'rgba(255, 255, 255, 0.6)',
          textAlign: 'center',
          mb: 4,
          maxWidth: 400,
        }}
      >
        NBA player impact analysis and rate statistics to optimize your lineups
      </Typography>

      {/* Sign In Button */}
      <Button
        variant="contained"
        onClick={handleSignIn}
        sx={{
          width: { xs: '100%', sm: 300 },
          maxWidth: 300,
          py: 1.5,
          bgcolor: '#005CCE',
          color: 'white',
          fontFamily: '"Instrument Sans", sans-serif',
          fontWeight: 600,
          fontSize: 16,
          textTransform: 'none',
          borderRadius: '8px',
          mb: 3,
          '&:hover': {
            bgcolor: '#0048A8',
          },
        }}
      >
        Sign In
      </Button>

      {/* Need an Account link */}
      <Typography
        sx={{
          fontFamily: '"Instrument Sans", sans-serif',
          fontWeight: 400,
          fontSize: 14,
          color: 'rgba(255, 255, 255, 0.6)',
        }}
      >
        Need an Account?{' '}
        <Link
          href="https://stokastic.com/pricing"
          sx={{
            color: '#4DA3FF',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          View Plans
        </Link>
      </Typography>
    </Box>
  );
};

export default UnlockOverlay;
